export default __webpack_public_path__ + "static/media/placeholder.07ef2fd6.jpeg";